<template>
  <v-row class="paragraph-block no-gutters">
    <v-col cols="12" :lg="noOffset ? 12 : 10" :xl="noOffset ? 12 : full ? 10 : 8" class="my-5">
      <transition appear name="from-below"><MarkdownBlock :class="{'pl-sm-10': !full}" :text="data.text"/> </transition>
    </v-col>
  </v-row>
</template>

<script>
import { MarkdownBlock } from '@monogrid/vue-lib'

export default {
  name: 'ContentParagraph',
  components: {
    MarkdownBlock
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    full: {
      type: Boolean,
      default: false
    },
    noOffset: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.paragraph-block {
  color: map-get(map-get($material-light, 'text'), 'secondary');
}
</style>
